import { QIconButton, QStack, QTooltip } from '@captivateiq/quotient';

import type { MessageButtonSpec } from '@captivateiq/assistant/types';

type MessageButtonBarProps = {
  buttons: MessageButtonSpec[];
  align?: 'left' | 'right';
};

export const MessageButtonBar = ({ buttons, align = 'left' }: MessageButtonBarProps) => {
  if (buttons.length === 0) {
    return null;
  }

  return (
    <QStack
      direction="row"
      spacing="8px"
      sx={{ flexWrap: 'wrap', justifyContent: align === 'right' ? 'flex-end' : 'flex-start' }}
    >
      {buttons.map((button) => (
        <QTooltip placement="top" title={button.tooltip}>
          <QIconButton
            disabled={button.disabled}
            icon={button.icon}
            key={button.id}
            size="small"
            onClick={button.onClick}
          />
        </QTooltip>
      ))}
    </QStack>
  );
};
